"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConditionRule = void 0;
var rule_1 = require("./rule");
var condition_type_1 = require("./condition-type");
var ConditionRule = /** @class */ (function (_super) {
    __extends(ConditionRule, _super);
    /**
     * Creates a rule that asserts a condition based on a predicate
     * @param rootType The model type the rule is for
     * @param options The options for the rule, of type ConditionRuleOptions
     */
    function ConditionRule(rootType, options) {
        var _this = this;
        // automatically run the condition rule during initialization of new and existing instances
        options.onInit = true;
        // call the base rule constructor
        _this = _super.call(this, rootType, options.name, options) || this;
        // assertion function
        _this.assert = options.assert;
        // message
        _this.message = options.message;
        // condition type
        _this.conditionType = options.conditionType ? (typeof options.conditionType === "string" ?
            condition_type_1.ConditionType.get(options.conditionType) :
            options.conditionType) :
            rule_1.Rule$ensureConditionType(options.name, rootType, options.category || "Error");
        // properties
        _this.properties = options.properties;
        return _this;
    }
    // asserts the condition and adds or removes it from the model if necessary
    ConditionRule.prototype.execute = function (entity) {
        var assert;
        var message;
        if (this.assert) {
            // If an assert function is defined, then use it to determine whether to attach a condition
            assert = this.assert.call(entity);
            message = typeof this.message === "string" ? this.message : this.message.call(entity);
        }
        else if (this.message instanceof Function) {
            message = this.message.call(entity);
            assert = typeof message === "string" && message.trim().length > 0;
        }
        // create or remove the condition if necessary
        if (typeof assert !== "undefined") {
            // pass through "this" so it can add the source when the rule is constructed
            // Add the source to the condition instead of the condition type
            this.conditionType.when(this, assert, entity, message);
        }
    };
    // gets the string representation of the condition rule
    ConditionRule.prototype.toString = function () {
        return typeof this.message === "string" ? this.message : this.conditionType.message;
    };
    return ConditionRule;
}(rule_1.Rule));
exports.ConditionRule = ConditionRule;
